var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.layout)?[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.path})],1)]:[_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }